import { Button } from '@monksflow/monks-ui';
import { PlusIcon, Trash2Icon } from 'lucide-react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SentimentSadIcon from '@/shared/assets/images/sentiment_sad.svg';
import { OptimizedImage } from '@/shared/ui';

import { FieldLabel, FormSection, PersonaTextField } from '../../PersonaFormSections';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function PainsSection() {
  const { t } = useTranslation('audiences');

  const { control, painsArray } = useEditPersonaFormContext();
  const { fields, append, remove } = painsArray;
  const canDelete = fields.length > 1;

  return (
    <FormSection
      icon={<OptimizedImage src={SentimentSadIcon} alt="" className="size-6" />}
      title={t('audiences.painsSection.pains')}
      badgeVariant="destructive"
      headerAction={
        <Button
          size="sm"
          onClick={() =>
            append({
              description: '',
            })
          }
        >
          {t('audiences.painsSection.addPain')}
          <PlusIcon />
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        <FieldLabel required={isNestedFieldRequired('pains', 'description')}>
          {t('audiences.painsSection.description')}
        </FieldLabel>

        {fields.map((field, index) => (
          <div key={field.id} className="flex items-start gap-4">
            <Controller
              name={`pains.${index}.description`}
              control={control}
              render={({ field: descField, fieldState: { error } }) => (
                <PersonaTextField
                  {...descField}
                  className="flex-1"
                  aria-label={t('audiences.painsSection.description')}
                  placeholder={t('audiences.painsSection.description')}
                  error={error?.message}
                />
              )}
            />
            <Button
              variant="ghost"
              size="icon"
              // Tessra has no ghost-destructive variant; the red is the affordance.
              className="mt-0.5 text-destructive"
              aria-label={t('audiences.painsSection.removePain')}
              onClick={() => remove(index)}
              disabled={!canDelete}
            >
              <Trash2Icon />
            </Button>
          </div>
        ))}
      </div>
    </FormSection>
  );
}
